import { render, staticRenderFns } from "./EmailTemplateContainer.vue?vue&type=template&id=b74530a0&scoped=true&"
import script from "./EmailTemplateContainer.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateContainer.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateContainer.vue?vue&type=style&index=0&id=b74530a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74530a0",
  null
  
)

export default component.exports